import { render, staticRenderFns } from "./DetailPenerbitanDiterimaPenilaianTeknis.vue?vue&type=template&id=1219dfb4&"
import script from "./DetailPenerbitanDiterimaPenilaianTeknis.vue?vue&type=script&lang=js&"
export * from "./DetailPenerbitanDiterimaPenilaianTeknis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports